import { useState } from "react";
import { hotList, features } from "@/mocks/feed";
import SectionHeading from "./SectionHeading";

export default function HotRank() {
  const [tab, setTab] = useState<"day" | "week">("day");

  return (
    <section id="hot" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="热度雷达 · 实时榜单"
            title="今日吃瓜热榜"
            desc="按现场关注度实时排行的前线榜单，标红的都是正在发酵、值得盯梢的爆点。"
          />
          <div className="inline-flex w-fit items-center rounded-full border border-background-300 bg-background-50 p-1">
            {[
              { id: "day" as const, label: "今日" },
              { id: "week" as const, label: "本周" },
            ].map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => setTab(t.id)}
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  tab === t.id ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ol className="grid gap-3">
              {hotList.map((h) => (
                <li key={h.rank} className="animate-rise" style={{ animationDelay: `${h.rank * 40}ms` }}>
                  <a
                    href="#feed"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 hover:bg-primary-50/40 cursor-pointer"
                  >
                    <span className="flex h-10 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary-100 font-heading text-lg font-extrabold text-secondary-800">
                      {h.rank}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2">
                        {h.live ? (
                          <i className="ri-record-circle-fill animate-live text-primary-500" aria-hidden="true"></i>
                        ) : null}
                        <span className="truncate text-sm font-semibold text-foreground-950 md:text-base">{h.title}</span>
                      </span>
                      <span className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                          {h.category}
                        </span>
                        <span className="flex items-center gap-1 text-primary-600">
                          <i className="ri-fire-fill" aria-hidden="true"></i> 热度 {h.heat}
                        </span>
                      </span>
                    </span>
                    <div className="hidden w-24 shrink-0 sm:block">
                      <div className="mb-1 flex items-center justify-between text-[11px] text-foreground-500">
                        <span>关注度</span>
                        <span className="font-semibold text-foreground-700">{h.heat}%</span>
                      </div>
                      <div className="h-1.5 w-full overflow-hidden rounded-full bg-secondary-100">
                        <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${h.heat}%` }}></div>
                      </div>
                    </div>
                    <span className="hidden rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800 lg:inline-block whitespace-nowrap">
                      {h.tag}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:col-span-4" aria-label="前线准则">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                  <i className="ri-list-check-3" aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950">吃瓜前线准则</h3>
                  <p className="text-xs text-foreground-500">我们为什么这样扒瓜</p>
                </div>
              </div>
              <ul className="mt-4 space-y-3.5">
                {features.map((f) => (
                  <li key={f.title} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${f.icon} text-sm`} aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-950">{f.title}</span>
                      <span className="mt-0.5 block text-xs leading-relaxed text-foreground-600">{f.desc}</span>
                    </span>
                  </li>
                ))}
              </ul>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
              >
                了解前线准则 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}